import axios from "axios";

type ProductInquiryFormPayload = {
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  city: string;
  state: string;
  country: {
    name?: string;
    code: string;
  };
  store: string;
  lotCode: string;
  orderNumber: string;
  subject: string;
  message: string;
};

interface ZendeskServiceInterface {
  createProductInquiry: (payload: ProductInquiryFormPayload) => Promise<void>;
}

export const ZendeskService: ZendeskServiceInterface = {
  createProductInquiry: async ({
    email,
    state,
    city,
    firstName,
    lastName,
    country,
    phoneNumber,
    store,
    lotCode,
    message,
    orderNumber,
    subject,
  }) => {
    try {
      const getBody = () => {
        return `
      First Name:
      ${firstName}
      
      Last Name:
      ${lastName}  
      
      Email:
      ${email}  
          
      Phone Number:
      ${phoneNumber}
      
      Country:
      ${country?.code}, ${country?.name}
      
      State:
      ${state}
      
      City:
      ${city}
      
      Store:
      ${store}
      
      Order Number:
      ${orderNumber}
      
      Lot Code:
      ${lotCode}
      
      Subject:
      ${subject}
      
      Message:
      ${message}
      `;
      };
      const payload = {
        request: {
          subject,
          comment: {
            body: getBody(),
          },
          requester: {
            name: `${firstName} ${lastName}`,
            email,
          },
          via: {
            channel: "web",
            source: "Product Inquiry",
            rel: null,
          },
        },
      };
      await axios.post(
        "https://r5smjqi7s8.execute-api.us-west-2.amazonaws.com/beyondmeat/zendesk/tickets",
        payload
      );
    } catch (e) {
      console.log(e);
    }
  },
};
